// vite doesn't define a global field in window, which some libraries rely on
window.global ||= window;
